<template>
    <!-- 对话框 -->
    <el-dialog title="减免配置" :visible.sync="show" :before-close="closeDialog" max-width="70%" append-to-body>
        <!-- 基本信息表单 -->

        <template>
            <div style="padding: 20px; width: 90%" v-loading="loading">
                <!-- 标题 -->
                <h2>司机加速包规则说明</h2>

                <div v-if="msg == '暂无数据'" style="text-align:center;margin-top:50px"><h2>暂无配置...</h2></div>
                <div v-if="msg == ''">
                    <div class="div-class" style="margin-top: 20px">
                        承担方：司机<span class="red">{{ submit_data.driver_bear_rate }}%</span>，公司<span class="red"
                            >{{ submit_data.company_bear_rate }}%</span
                        >
                    </div>
                    <div v-if="submit_data.type == '0'">
                        <div class="div-class">
                            <span style="color: blue">说明</span>：司机超时到达大于<span class="red">{{
                                submit_data.reduction_duration
                            }}</span
                            >分，每超时<span class="red">{{ submit_data.exceed_minute }}</span
                            >分钟，优惠<span class="red">{{ submit_data.exceed_fee }}</span
                            >元
                        </div>
                        <div class="div-class">
                            封顶金额：<span class="red">{{ submit_data.fee_top }}</span
                            >元
                        </div>
                    </div>
                    <div v-if="submit_data.type == '1'">
                        <div class="div-class">
                            减免基数：订单金额大于<span class="red">{{ submit_data.order_amount_greater }}</span
                            >元，取<span class="red">{{ submit_data.order_amount_greater_compute }}</span
                            >元，小于<span class="red">{{ submit_data.order_amount_less }}</span
                            >元，取<span class="red">{{ submit_data.order_amount_less_compute }}</span
                            >元，大于<span class="red">{{ submit_data.order_amount_less }}</span
                            >元,小于<span class="red">{{ submit_data.order_amount_greater }}</span
                            >元取实际金额
                        </div>
                        <div class="div-class">
                            <span style="color: green">说明</span>：司机超时大于<span class="red">{{ submit_data.go_way_time_less }}</span
                            >分钟,小于<span class="red">{{ submit_data.go_way_time_greater }}</span
                            >分钟，优惠减免基数的<span class="red">{{ submit_data.go_way_time_less_amount }}%</span>，超时大于<span
                                class="red"
                                >{{ submit_data.go_way_time_greater }}</span
                            >分钟优惠减免基数的<span class="red">{{ submit_data.go_way_time_greater_amount }}%</span>。
                        </div>
                    </div>
                </div>
            </div>

            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center; margin-top: 20px">
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            console.log(_this.data, 'data');
            // _this.search_data.city_code = _this.data.city_code;
            // _this.search_data.city_tag = _this.data.city_tag;
            _this.search_data.order_code = _this.data.order_code;
            // _this.submit_data.order_code = _this.data.city_tag;

            _this.getDelayReductionConf(); // 获取详情
        }
    },

    data() {
        return {
            show: false,
            msg: '',
            loading: false,
            // 表单数据
            submit_data: {
                // status: "", // 开关
                // delay_fee: "", // 司机加速包金额
                company_bear_rate: '', // 公司承担百分比
                driver_bear_rate: '', // 司机承担百分比

                // type: "0", // 分类
                reduction_duration: '', // 免减时长
                exceed_minute: '', // 每超（分钟）
                exceed_fee: '', // 减免
                fee_top: '', // 减免封顶
                go_way_time_less: '', // 接驾时长大于
                go_way_time_less_amount: '', // 接驾时长大于 减免金额
                go_way_time_greater: '', // 接驾时长大于
                go_way_time_greater_amount: '', // 接驾时长大于 减免金额

                order_amount_less: '', // 订单金额小于
                order_amount_less_compute: '', // 订单金额小于 按金额计算
                order_amount_greater: '', // 订单金额大于
                order_amount_greater_compute: '' // 订单金额大于 按金额计算

                // third_auth: "", // 第三方
                // order_code: sessionStorage.getItem("city_code"),
                // protocol: "", // 协议内容
            },

            search_data: {
                order_code: '',
                coordinate: '1',
                synchronization: '1',
                order_track: '1',
                order_difference: '1'
                // city_code: "",
                // city_tag: "",
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.msg = '';
            _this.submit_data = {
                // status: "", // 开关
                // delay_fee: "", // 司机加速包金额
                company_bear_rate: '', // 公司承担百分比
                driver_bear_rate: '', // 司机承担百分比

                // type: "0", // 分类
                reduction_duration: '', // 免减时长
                exceed_minute: '', // 每超（分钟）
                exceed_fee: '', // 减免
                fee_top: '', // 减免封顶
                go_way_time_less: '', // 接驾时长大于
                go_way_time_less_amount: '', // 接驾时长大于 减免金额
                go_way_time_greater: '', // 接驾时长大于
                go_way_time_greater_amount: '', // 接驾时长大于 减免金额

                order_amount_less: '', // 订单金额小于
                order_amount_less_compute: '', // 订单金额小于 按金额计算
                order_amount_greater: '', // 订单金额大于
                order_amount_greater_compute: '' // 订单金额大于 按金额计算

                // third_auth: "", // 第三方
                // order_code: sessionStorage.getItem("city_code"),
                // protocol: "", // 协议内容
            };

            _this.search_data = {
                order_code: '',
                coordinate: '1',
                synchronization: '1',
                order_track: '1',
                order_difference: '1'
                // city_code: "",
                // city_tag: "",
            };
        },

        // 获取详情
        getDelayReductionConf() {
            _this.loading = true;
            _this
                .$post('/order/getOrderDetails', _this.search_data)
                .then((res) => {
                    _this.loading = false;

                    if (res.data.order_delay_reduction_records == '') {
                        _this.msg = '暂无数据';
                        return;
                    } else {
                        //   _this.submit_data.status = res.data.status.val;
                        _this.submit_data.reduction_duration = res.data.order_delay_reduction_records.reduction_duration; // 免减时长（分钟） 30分钟
                        //   _this.submit_data.delay_fee = res.data.order_delay_reduction_records.delay_fee;
                        _this.submit_data.exceed_minute = res.data.order_delay_reduction_records.exceed_minute; // 每超
                        _this.submit_data.exceed_fee = res.data.order_delay_reduction_records.exceed_fee; // 减免 优惠
                        _this.submit_data.fee_top = res.data.order_delay_reduction_records.fee_top; // 封顶
                        _this.submit_data.company_bear_rate = res.data.order_delay_reduction_records.company_bear_rate; // 公司承担
                        _this.submit_data.driver_bear_rate = res.data.order_delay_reduction_records.driver_bear_rate; // 司机承担
                        //   _this.submit_data.third_auth = res.data.order_delay_reduction_records.third_auth;
                        //   _this.submit_data.protocol = res.data.order_delay_reduction_records.protocol;

                        _this.submit_data.type = res.data.order_delay_reduction_records.type;
                        _this.submit_data.go_way_time_greater = res.data.order_delay_reduction_records.go_way_time_greater;
                        _this.submit_data.go_way_time_greater_amount = res.data.order_delay_reduction_records.go_way_time_greater_amount;
                        _this.submit_data.go_way_time_less = res.data.order_delay_reduction_records.go_way_time_less;
                        _this.submit_data.go_way_time_less_amount = res.data.order_delay_reduction_records.go_way_time_less_amount;
                        _this.submit_data.order_amount_less = res.data.order_delay_reduction_records.order_amount_less;
                        _this.submit_data.order_amount_less_compute = res.data.order_delay_reduction_records.order_amount_less_compute;
                        _this.submit_data.order_amount_greater = res.data.order_delay_reduction_records.order_amount_greater;
                        _this.submit_data.order_amount_greater_compute =
                            res.data.order_delay_reduction_records.order_amount_greater_compute;
                    }
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.red {
    color: red;
}
.div-class {
    margin-bottom: 20px;
}
</style>
